import { AloUser } from '@/models/alo/AloUser'
import { AloSecurityItem } from '@/models/alo/AloSecurityItem';
import { getDefaultSecurityRights } from '@/enum/SecurityItems';
import { AloFlux } from '@/models/alo/AloFlux';
import { StateItem, buildStateItem } from '@/models/alo/StateItem';
import { AloPartenaire } from '@/models/alo/AloPartenaire';
import { AloDataSource } from '@/models/alo/AloDataSource';
import { AloMeta } from '@/models/alo/AloMeta';
import { AloFeedDownload } from '@/models/alo/AloFeedDownload';
import { AloPersonne } from '@/models/alo/AloPersonne';
import { AloFacetteType } from '@/models/alo/AloFacetteType';
import { AloProfilExclusion } from '@/models/alo/AloProfilExclusion';
import { AloGroupCarac } from '@/models/alo/AloGroupCarac';
import { AloCarac } from '@/models/alo/AloCarac';

export interface IAdministrationState { 
  fluxStatus: string;
  flux: {[id:number]:AloFlux}
  fluxList: StateItem<number[]>
  
  partenaireStatus: string
  partenaire: {[id:number]:AloPartenaire}
  partenaireList: StateItem<number[]>

  dataSourcesStatus: string
  dataSources: {[id:number]:AloDataSource}
  dataSourcesList: StateItem<number[]>

  feedDownloadsStatus: string
  feedDownloads: {[id:number]:AloFeedDownload}
  feedDownloadsList: StateItem<number[]>

  personneStatus: string
  personneDic: {[id:number]:AloPersonne}
  personneList: StateItem<number[]>

  profilExclusionStatus: string;
  profilExclusion: {[id:number]:AloProfilExclusion}
  profilExclusionList: StateItem<number[]>

  groupCaracStatus: string;
  groupCarac: {[id:number]:AloGroupCarac}
  groupCaracList: StateItem<number[]>

  caracStatus: string;
  carac: {[id:number]:AloCarac}
  caracList: StateItem<number[]>
  
}

//Initial State
const state: IAdministrationState = {  
  fluxStatus:'',
  flux: {} as {[id:number]:AloFlux},
  fluxList: buildStateItem([] as number[],-5),

  partenaireStatus:'',
  partenaire: {} as {[id:number]:AloPartenaire},
  partenaireList: buildStateItem([] as number[],-5),

  dataSourcesStatus:'',
  dataSources: {} as {[id:number]:AloDataSource},
  dataSourcesList: buildStateItem([] as number[],-5),

  feedDownloadsStatus:'',
  feedDownloads:{} as {[id:number]:AloFeedDownload},
  feedDownloadsList: buildStateItem([] as number[],-5),   

  personneStatus:'',
  personneDic: {} as {[id:number]:AloPersonne},
  personneList: buildStateItem([] as number[],-5),

  profilExclusionStatus:'',
  profilExclusion: {} as {[id:number]:AloProfilExclusion},
  profilExclusionList: buildStateItem([] as number[],-5),

  groupCaracStatus:'',
  groupCarac: {} as {[id:number]:AloGroupCarac},
  groupCaracList: buildStateItem([] as number[],-5),

  caracStatus:'',
  carac: {} as {[id:number]:AloCarac},
  caracList: buildStateItem([] as number[],-5),

}
export default state